import './ModalIndexCard.scss'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { Row, Col, Input, Modal, Button, Icon, Select, message, Radio, Table } from 'antd'
import { ModalPdfViewer } from '../../../../../InterestConflicts/components'
import { useTranslation } from 'react-i18next'
import { getFormPromise, saveStatePromise, saveCommentsPromise } from '../../promises'
import { HistoryModal } from '../../../../../../layouts/Private/components'
import { ReportService } from '../../../../../../services'
import { camelizerHelper } from '../../../../../../helpers'

const ModalIndexCard = ({item, handleCancel}) => {

  const [seeMore1, setSeemore1] = useState(false);
  const [seeMore2, setSeemore2] = useState(false);
  const [seeMore4, setSeemore4] = useState(false);
  const [seeMore5, setSeeMore5] = useState(false);
  const [seeMore6, setSeeMore6] = useState(true);
  const [itemTable, setItemTable] = useState(item);
  const [formId, setFormId] = useState(null);
  const { t } = useTranslation();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [statusComments, setStatusComments] = useState(null);
  const [comments, setComments] = useState("");
  const [title, setTitle] = useState(null);
  const [isHistoryVisible, setIsHistoryVisible] = useState(false);
  const [lastCommentDate, setLastCommentDate] = useState(null);
  const [ resendOnBoardingForm, setResendOnBoardingForm ] = useState(false);
  const [ loadingAttch ,setLoadingAttch ] = useState(false)

  useEffect(() => {
    getFormPromise(item.id).then((response) => {
      setItemTable(response.data);
      if(response.data?.relations?.length > 0) {
        setSeeMore5(true)
      }
      if(response.data.histComments.length > 0){
        setLastCommentDate(moment(response.data.histComments[0].creationDate).format('DD/MM/YYYY HH:mm'));
      }
    })
  }, []);


  const handleMore1 = () => {
    if (seeMore1 === false){
      setSeemore1(true)
    }else
      setSeemore1(false)
  }

  const handleMore2 = () => {
    if (seeMore2 === false){
      setSeemore2(true)
    }else
      setSeemore2(false)
  }

  const handleMore4 = () => {
    if (seeMore4 === false){
      setSeemore4(true)
    }else
      setSeemore4(false)
  }

  const renderTypeDeclarationInputs = () => {
    let temp = []

    if (item.type === 'GIFT'){
      temp.push(
          {
            label: t('messages.aml.cdi.formManager.giftingCompany'),
            data: itemTable?.reunion?.organism
          },
          {
            label: t('messages.aml.cdi.formManager.giftType'),
            data: itemTable?.reunion?.type
          },
          {
            label: t('messages.aml.cdi.formManager.estimatedValue'),
            data: itemTable?.reunion?.value
          }
        )
    }
    if (item.type === 'TRAVEL'){
      temp.push(
        {
          label: t('messages.aml.cdi.formManager.giftingCompany'),
          data: itemTable?.reunion?.organism
        },
        {
          label: t('messages.aml.cdi.formManager.destination'),
          data: itemTable?.reunion?.place
        },
        {
          label: t('messages.aml.cdi.formManager.estimatedValue'),
          data: itemTable?.reunion?.value
        }
      )
    }
    if (item.type === 'FP'){
      temp.push(
        {
          label: t('messages.aml.cdi.formManager.officerName'),
          data: itemTable?.recipient?.record?.nombre
        },
        {
          label: t('messages.aml.cdi.formManager.meetingType'),
          data: itemTable?.reunion?.type
        },
        {
          label: t('messages.aml.cdi.formManager.meetingDate'),
          data: moment(itemTable?.reunion?.date).format('DD/MM/YYYY')
        }
      )
    }
    if (item.type === 'SOC'){
      temp.push(
        {
          label: t('messages.aml.cdi.formManager.officerName'),
          data: itemTable?.recipient?.record?.nombre
        },
        {
          label: t('messages.aml.cdi.formManager.meetingDate'),
          data: moment(itemTable?.reunion?.date).format('DD/MM/YYYY')
        },
        {
          label: t('messages.aml.cdi.formManager.associationName'),
          data: itemTable?.reunion?.summary
        }
      )
    }
    return temp
  }

  const varStateOptions = (actualState) => {
    var options = [];
    if (actualState === 'EVALUACION'){
      options.push(
        {val: "AUTORIZADA", label: t('messages.aml.cdi.status.authorized')},
        {val: "RECHAZADA", label: t('messages.aml.cdi.status.rejected')},
        {val: "OBSERVADA", label: t('messages.aml.cdi.status.observed')}
      );
    }else if (actualState === 'AUTORIZADA'){
      options.push(
        {val: "EVALUACION", label: t('messages.aml.cdi.status.done')},
        {val: "RECHAZADA", label: t('messages.aml.cdi.status.rejected')},
        {val: "OBSERVADA", label: t('messages.aml.cdi.status.observed')}
      );
    }else if(actualState === 'RECHAZADA'){
      options.push(
        {val: "EVALUACION", label: t('messages.aml.cdi.status.done')},
        {val: "AUTORIZADA", label: t('messages.aml.cdi.status.authorized')},
        {val: "OBSERVADA", label: t('messages.aml.cdi.status.observed')}
      );
    }else if (actualState === 'OBSERVADA'){
      options.push(
        {val: "EVALUACION", label: t('messages.aml.cdi.status.done')},
        {val: "AUTORIZADA", label: t('messages.aml.cdi.status.authorized')},
        {val: "RECHAZADA", label: t('messages.aml.cdi.status.rejected')}
      );
    }
    return options;
  }

  const handlePdfViewer = (record) => {
    setFormId(record.id);
  }

  const onCancelPdfViewer = () => {
    setFormId(null);
  }

  const handleSaveStatus = () => {
      saveStatePromise(item.id, selectedStatus, statusComments, resendOnBoardingForm).then((response) => {
        if(response.success === true){
          message.success(t('messages.aml.cdi.formManager.stateSaveSuccess'));
          handleCancel();
        }else{
          message.error(t('messages.aml.cdi.formManager.stateSaveError'));
        }
      })
  }

const handleSaveAttachment = () => {
  const formData = new FormData()
    formData.append( 'formId', item.id)
    formData.append('title', title)
    formData.append('comments', comments)
    saveCommentsPromise(formData).then((response) => {
      if(response.success === true){
        message.success(t('messages.aml.commentSaved'))
        setItemTable(response.data)
        setLastCommentDate(moment(response.data.histComments[0].creationDate).format('DD/MM/YYYY HH:mm'));
        setComments(null);
        setTitle(null);
      }else{
        message.error(t('messages.aml.errorSavingComment'))
        setLoadingAttch(false)
      }
    })
  }

  const handleOnChangeStatus = (value) => {
    setSelectedStatus(value);
  }

  const handleCommentsStateChange = (comment) => {
    setStatusComments(comment);
  }

  const handleTitle = (title) => {
    setTitle(title);
  }

  const handleComments = (comment) => {
    setComments(comment);
  }

  const relationColumn = (rowRecord) => {
    return [
      {
        title: t('messages.aml.cdi.formManager.documentColumn'),
        dataIndex: 'rutRelated',
        width: '14%'
      },
      {
        className: 'relatedTitle',
        title: t('messages.aml.cdi.formManager.relatedDeclConsulted', { folio: itemTable?.folio }),
        width: '43%',
        render: (record) => {
          return (
            <Row gutter={[0,8]}>
              <Col span={24}>
                {record.sectionOrig ? record.sectionOrig : t('messages.aml.cdi.formManager.identifiedInRegistry')}
              </Col>
              <Col span={8}>
                {record.relationOrig}
              </Col>
              <Col span={8}>
                {record.nameOrig}
              </Col>
              <Col span={8}>
                {record.companyOrig}
              </Col>
            </Row>
          )
        }
      },
      {
        title: rowRecord.formRelated && rowRecord.relations?.filter(r => r.sectionRel).length > 0
          ? t('messages.aml.cdi.formManager.linkedDeclaration', { folio: rowRecord.formRelated?.folio })
          : t('messages.aml.records'),
        className: 'vinculadaTitle',
        width: '43%',
        render: (record) => {
          return (
            <Row gutter={[0,8]}>
              <Col span={24}>
                {record.sectionRel ? record.sectionRel : t('messages.aml.cdi.formManager.identifiedInRegistry')}
              </Col>
              <Col span={8}>
                {record.relationRel}
              </Col>
              <Col span={8}>
                {record.nameRel}
              </Col>
              <Col span={8}>
                {record.companyRel}
              </Col>
            </Row>
          )
        }
      }
    ]
  }

  const tableColumns = [
    {
      title: t('messages.aml.onboarding.modalIndexCard.schemaName'),
      dataIndex: 'name',
      render: (text) => {
        return camelizerHelper(text)
      }
    },
    {
      title: t('messages.aml.rut'),
      dataIndex: 'rut'
    },
    {
      title: t('messages.aml.category'),
      dataIndex: 'category',
      render: (text, record) => t('messages.aml.category.' + text)
    },
    {
      title: t('messages.aml.folio'),
      dataIndex: 'formRelated',
      render: (text, record) => {
        return record && record.formRelated ? record.formRelated.folio : '-'
      }
    },
    {
      title: t('messages.aml.cdi.formManager.completedDate'),
      dataIndex: 'formRelated.receiveDate',
      render: (text, record) => {
        return record.formRelated ? moment(text).format('DD/MM/YYYY') : '-'
      }
    },
    {
      title: t('messages.aml.cdi.formManager.viewDeclaration'),
      render: (text, record) => record.formRelated && <Button onClick={() => setFormId(record.formRelated.id)} icon="file-pdf" size='small'></Button>
    }
  ]

  const handleGetFile = async (originalName) => {
    const obj = {
      formId: item.id,
      fileName: originalName,
    }
    await ReportService.read('/getFileForm', obj, null, originalName)
  }

  const handleCloseModals = () => {
    setIsHistoryVisible(false);
  }

  const commentSchema = [
    {
      title: t('messages.aml.onboarding.modalIndexCard.schemaDate'),
      dataIndex: 'creationDate',
      cols: 4
    },
    {
      title: t('messages.aml.onboarding.modalIndexCard.schemaName'),
      dataIndex: 'userName',
      cols: 8
    },
    {
      title: t('messages.aml.onboarding.modalIndexCard.schemaTitle'),
      dataIndex: 'title',
      cols: 12
    },
  ];

    return (
      <div className="modIndexCard">
        <Row className="titleRow" onClick={handleMore1}>
          <Col span={6}>
            <h3>{t('messages.aml.onboarding.modalIndexCard.basicInfoTitle')}</h3>
          </Col>
          <Col span={4} push={16}>
            <Button type="link" onClick={handleMore1}>{t('messages.aml.seeMore')}<Icon type={seeMore1 ? "minus" : "plus"}/></Button>
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col span={6} >
            {t('messages.aml.onboarding.modalIndexCard.nameOrLegal')}
            <Input readOnly value={itemTable?.json?.basicInformation?.basicInfo ? itemTable.json.basicInformation.basicInfo.name : item.name}/>
          </Col>
          <Col span={5} offset={1}>
            {t('messages.aml.onboarding.modalIndexCard.documentType')}
            <Input readOnly value={itemTable?.json?.basicInformation?.basicInfo ? itemTable.json.basicInformation.basicInfo.tipoDocumento: itemTable?.recipient?.record?.tipoDoc}/>
          </Col>
          <Col span={5} offset={1}>
            {t('messages.aml.onboarding.modalIndexCard.documentNumber')}
            <Input readOnly value={itemTable?.json?.basicInformation?.basicInfo ? itemTable.json.basicInformation.basicInfo.nroDocumento : item.rut} />
          </Col>
          <Col span={5} offset={1}>
            {t('messages.aml.cdi.formManager.email')}
            <Input readOnly value={itemTable?.recipient?.record?.email ?? item?.email} />
          </Col>
          
        </Row>
        {seeMore1 &&
          <Row className="div-more-info">
            <Col span={7}>
              {t('messages.aml.company')}
              <Input readOnly value={itemTable.recipient.record.subcliente ? itemTable.recipient.record.subcliente.name : t('messages.aml.onboarding.modalIndexCard.noCompanyAssigned')}/>
            </Col>
            <Col span={7} offset={1}>
              {t('messages.aml.cdi.advanced.area')}
              <Input readOnly value={itemTable.recipient.record.area}/>
            </Col>
            <Col span={7} offset={1}>
              {t('messages.aml.onboarding.modalIndexCard.personType')}
              <Input readOnly value={itemTable.recipient && itemTable.recipient.record.type === 'Person' ? t('messages.aml.onboarding.modalIndexCard.naturalPerson') : t('messages.aml.onboarding.modalIndexCard.legalPerson')} />
            </Col>
            {/* <Col span={7} offset={1}>
              Grupo
              <Input readOnly value={itemTable.recipient.record.grupo ? itemTable.recipient.record.grupo : "Sin grupo asignado"}/>
            </Col> */}
          </Row>
        }
        {/* FIN INFORMACION BASICA */}
          <Row>
            <Col span={9}>
              <h3>{t('messages.aml.cdi.formManager.declarationInfoTitle')}</h3>
            </Col>
            {item.statusDecl !== 'PENDIENTE' &&
            <>
              <Col span={15}>
                <div className="button-box-index">
                  <Button type="primary" onClick={() => handlePdfViewer(item)}>{t('messages.aml.cdi.formManager.viewDeclaration')}<Icon type="file-pdf" /></Button>
                </div>
              </Col>
            </>
            }
              {formId &&
                <Modal
                  className="modal-pdf-viewer"
                  title={t('messages.aml.cdi.formManager.declaration')}
                  centered
                  width={1000}
                  header={null}
                  footer={[<Button key="back" onClick={onCancelPdfViewer}>{t('messages.aml.btnClose')}</Button>]}
                  onCancel={onCancelPdfViewer}
                  visible="true"
                  ><ModalPdfViewer
                    pdfId={formId}
                  />
                </Modal>
              }
          </Row>
          <hr/>
          {item.statusDecl !== 'PENDIENTE' && (itemTable.gerencia || itemTable.cargo) &&
          <Row gutter={[50]}>
            <Col span={12}>
              {t('messages.aml.cdi.formManager.management')}
              <Input readOnly value={itemTable.gerencia}/>
            </Col>
            <Col span={12}>
              {t('messages.aml.position')}
              <Input readOnly value={itemTable.cargo}/>
            </Col>
          </Row>
          }
          {itemTable?.json?.infoPep &&
            <Row gutter={[50]}>
              <Col span={12}>
                {t('messages.aml.cdi.formManager.isPep')}
                <Input readOnly value={itemTable.json.infoPep.isPep === 'Ser' ? 'SI' : 'NO'}/>
              </Col>
              <Col span={12}>
                {t('messages.aml.nationality')}
                <Input readOnly value={itemTable.json.infoPep.nationality}/>
              </Col>
            </Row>
          }
          <Row gutter={[50]}>
            <Col span={6} >
              {t('messages.aml.onboarding.modalIndexCard.state')}
              <Input readOnly value={t("messages.aml.formKycStatus."+item.statusDecl)}/>
            </Col>
            <Col span={6}>
              {t('messages.aml.onboarding.modalIndexCard.requestDate')}
              <Input readOnly value={moment(item.fecSolicitud).format('DD/MM/YYYY')}/>
            </Col>
            <Col span={6}>
              {t('messages.aml.onboarding.modalIndexCard.remindersCount')}
              <Input readOnly value={item.nroReminders && item.nroReminders > 0 ? item.nroReminders : t('messages.aml.onboarding.modalIndexCard.noReminders')}/>
            </Col>
            <Col span={6}>
              {t('messages.aml.onboarding.modalIndexCard.lastReminderDate')}
              <Input readOnly value={item.lastReminder ? moment(item.lastReminder).format('DD/MM/YYYY') : '-'} />
            </Col>
          </Row>
          {item.statusDecl !== 'PENDIENTE' &&
            <Row gutter={[50]}>
              <Col span={6}>
                {t('messages.aml.onboarding.modalIndexCard.receptionDate')}
                <Input readOnly value={moment(item.receiveDate).format('DD/MM/YYYY')}/>
              </Col>
              {item.statusDecl === 'AUTORIZADA' &&
                <Col span={6}>
                  {t('messages.aml.onboarding.modalIndexCard.authDate')}
                  <Input readOnly value={moment(itemTable.statusDate).format("DD/MM/YYYY")}/>
                </Col>
              }
              {item.statusDecl === 'RECHAZADA' &&
                <Col span={6}>
                  {t('messages.aml.onboarding.modalIndexCard.rejectDate')}
                  <Input readOnly value={moment(itemTable.statusDate).format("DD/MM/YYYY")}/>
                </Col>
              }
              {item.statusDecl === 'OBSERVADA' &&
                <Col span={6}>
                  {t('messages.aml.onboarding.modalIndexCard.observationDate')}
                  <Input readOnly value={item?.statusDate ? moment(item.statusDate).format('DD/MM/YYYY') : '---'}/>
                </Col>
              }
              {itemTable?.affirmative !== undefined &&
                <Col span={6}>
                  {t('messages.aml.cdi.formManager.affirmativeAnswers')}
                  <Input readOnly value={itemTable?.affirmative}/>
                </Col>
              }
              {itemTable.hasPositives !== undefined &&
                <Col span={6}>
                  {t('messages.aml.links')}
                  <Input readOnly value={itemTable?.hasPositives ? t('messages.aml.si') : t('messages.aml.no')}/>
                </Col>
              }
            </Row>
          }

          {/* FIN INFORMACION SOLICITUD REALIZADA */}
          <Row onClick={handleMore2}>
            <Col span={6}>
              <h3>{t('messages.aml.onboarding.modalIndexCard.comments')}</h3>
            </Col>
            <Col span={4} push={16}>
              <Button type="link" onClick={handleMore2}>{t('messages.aml.seeMore')} <Icon type={seeMore2 ? "minus" : "plus"}/></Button>
            </Col>
          </Row>
          <hr/>
          {seeMore2 &&
            <div className="div-more-info">
              <Row>
                <Col span={5} >
                  {t('messages.aml.onboarding.modalIndexCard.title')}
                  <Input onChange={(e) => {handleTitle(e.target.value)}} value={title}/>
                </Col>
                <Col span={18} push={1}>
                  {t('messages.aml.onboarding.modalIndexCard.comment')}
                  <Input.TextArea onChange={(e) => {handleComments(e.target.value)}} value={comments} placeholder={t('messages.aml.cdi.formManager.commentsMaxLength')}/>
                </Col>
              </Row>
              <Col span={6}>
                {lastCommentDate &&
                  <Button onClick={() => setIsHistoryVisible(true)} style={{padding:'unset'}} type="link">{t('messages.aml.onboarding.modalIndexCard.viewPreviousComments')}</Button>
                }
              </Col>
              <Col span={6}>
                <div>
                  {t('messages.aml.onboarding.modalIndexCard.lastComment')}: {lastCommentDate ? lastCommentDate : t('messages.aml.onboarding.modalIndexCard.noComments')}
                </div>
              </Col>
              <Col span={12}>
                <Button onClick={() => handleSaveAttachment()} style={{float:'right', padding:'unset'}} type="link">{t('messages.aml.save')}</Button>
              </Col>
              <Row>
              </Row>
            </div>
          }

          {isHistoryVisible &&
              <HistoryModal formId={item.id} flowType="attachment" schema={commentSchema} data={itemTable.histComments} closeHandler={handleCloseModals}/>
          }
          {/* FIN COMENTARIOS */}
        { item.statusDecl !== 'PENDIENTE' &&
          <>
            <Row onClick={handleMore4}>
              <Col span={10}>
                <h3>{t('messages.aml.modifyStatus')}</h3>
              </Col>
              <Col span={4} push={12}>
                <Button type="link" onClick={handleMore4}>{t('messages.aml.seeMore')} <Icon type={seeMore4 ? "minus" : "plus"}/></Button>
              </Col>
            </Row>
            <hr/>
            {seeMore4 &&
              <div className="status-box div-more-info">
                <Row>
                  <Col span={6} >
                    <h3>{t('messages.aml.changeStatus')}</h3>
                  </Col>
                  <Col span={8} push={10}>
                    <Select
                      style={{width: '100%'}}
                      defaultValue={t("messages.aml.formKycStatus."+item.statusDecl)}
                      onChange={handleOnChangeStatus}
                      >
                        {varStateOptions(item.statusDecl).map(option =>
                            <Select.Option value={option.val}>{option.label}</Select.Option>
                          )
                        }
                    </Select>
                  </Col>
                </Row>
                  {selectedStatus &&
                  <Modal
                    title={t('messages.aml.changeStatus')}
                    centered
                    width={700}
                    visible="true"
                    onCancel={() => setSelectedStatus(null)}
                    footer={[
                      <Button key="save" onClick={() => handleSaveStatus()}>{t('messages.aml.save')}</Button>
                    ]}
                    >
                      <Row>
                        <Col span={24}>
                          {t('messages.aml.cdi.formManager.stateChangeIntroPrefix')} {t("messages.aml.formKycStatus."+selectedStatus)}. <br/>
                          {t('messages.aml.cdi.formManager.stateChangeIntroLine2')}
                        </Col>
                      </Row>
                      <Row gutter={[0, 32]}>
                        <Col span={24}>
                          <Input.TextArea placeholder={t('messages.aml.onboarding.modalIndexCard.commentsPlaceholderState')} onChange={(e) => handleCommentsStateChange(e.target.value)} />
                        </Col>
                      </Row>
                      {selectedStatus === 'RECHAZADA' &&
                      <>
                        <Row gutter={[0, 32]}>
                          <Col span={20}>
                            {t('messages.aml.cdi.formManager.resendQuestion')}
                          </Col>
                          <Col span={4}>
                            <Radio.Group defaultValue={false} buttonStyle="solid" onChange={(e) => setResendOnBoardingForm(e.target.value)}>
                              <Radio.Button value={true}>{t('messages.aml.si')}</Radio.Button>
                              <Radio.Button value={false}>{t('messages.aml.no')}</Radio.Button>
                            </Radio.Group>
                          </Col>
                        </Row>
                      </>
                      }
                  </Modal>
                  }
              </div>
            }
            { itemTable?.relations?.length > 0 &&
              <>
                <Row onClick={() => setSeeMore5(!seeMore5)}>
                  <Col span={6}>
                    <h3>{t('messages.aml.links')}</h3>
                  </Col>
                  <Col span={4} push={16}>
                    <Button type="link" onClick={() => setSeeMore5(!seeMore5)}>{t('messages.aml.seeMore')} <Icon type={seeMore5 ? "minus" : "plus"}/></Button>
                  </Col>
                </Row>
                <hr/>
                {seeMore5 &&
                  <div className="div-more-info">
                      <Row>
                        <Col span={24} >
                          <Table pagination={false}
                          dataSource={itemTable?.groupRelations}
                          columns={tableColumns}
                          size='small'
                          expandedRowRender={rowRecord => <div className='expandable-relations-wrapper'> <Table size='small' dataSource={rowRecord.relations} columns={relationColumn(rowRecord)} bordered pagination={rowRecord.relations?.length > 10 } /> </div>
                          }
                          />
                        </Col>
                      </Row>
                  </div>
                }
              </>
            }
            {(item.type === 'GIFT' || item.type === 'TRAVEL' || item.type === 'FP' || item.type === 'SOC') &&
            <>
              <Row onClick={() => setSeeMore6(!seeMore6)}>
                <Col span={6}>
                  <h3>{t('messages.aml.cdi.formManager.relevantData')}</h3>
                </Col>
                <Col span={4} push={16}>
                  <Button type="link" onClick={() => setSeeMore6(!seeMore6)}>{t('messages.aml.seeMore')} <Icon type={seeMore6 ? "minus" : "plus"}/></Button>
                </Col>
              </Row>
              <hr/>
              {seeMore6 &&
                  <div className="div-more-info">
                    <Row gutter={[30]}>
                      {renderTypeDeclarationInputs().map( item => 
                        <Col span={8}>
                          {item.label}
                          <Input value={item.data} readOnly/>
                        </Col>
                      )
                      }
                    </Row>
                  </div>
                }
            </>
            }
          </>
        }
      </div>
    );
}
export default ModalIndexCard
